import { Modal, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { URInput } from '../../../../shared/widgets/input';
import dropbox from "../../../../styles/images/dropbox.svg";
import bluefolder from "../../../../styles/images/bluefolder.svg";
import notes from "../../../../styles/images/notessvg.svg";
import iconimage from "../../../../styles/images/grid_image.svg";
import iconmusic from "../../../../styles/images/grid_music.svg";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconword from "../../../../styles/images/grid_word.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import { TPIService } from '../../../../base/tpiService';
import { initialStateModel,dropboxState } from '../../../../models/model';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { excelFormats, imageFormat, mp3Formats, pptFormats, wordFormats, zipFormats } from '../../../../base/utils';
import store from '../../../../context/store/store';
const mime = require('mime');
const DropBoxUpload = () =>{
  const dropboxState: dropboxState =
    useSelector((state: initialStateModel) => state.DropBoxStorageReducerState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [toggleViews, setToggleView] = useState(false);
  const [toggleFiles,setToggleFile] = useState<Array<any>>(dropboxState.dropBoxFiles);
  const dropRef = useRef<number>(1);
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
  const [tokens, setTokens] = useState('');
  const [dropBoxbtnhide, setDropBoxbtnhide] = useState(false);
  useEffect(()=>{
    if(dropRef.current===1 && dropboxState.dropBoxFiles.length>0){
      setToggleFile(dropboxState.dropBoxFiles);
      dropRef.current=2;
    }
   
  },[toggleFiles,dropboxState.dropBoxFiles]);
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  
  const openDropBox = () => {
    setIsModalVisible(true);
  };
  const loginOAuth = async() => {
    TPIService.commonBridgeAuth("drop_box");
    const dropboxStorage:any = localStorage.getItem('drop_box');
    const dropboxStore:any = JSON.parse(dropboxStorage);
    const dropbox = await TPIService.getClientsCloud("drop_box");
    if(dropboxStore && dropboxStore.access_token && dropbox &&
        dropbox.statusCode===200 && Array.isArray(dropbox.onedrive) &&
    dropbox.onedrive.length>0 && dropbox.onedrive[0].dropbox){
      openDropBox();
      await TPIService.fetchDropBoxUserFiles
      (dropboxStore.access_token,"",{dropbox:dropbox.onedrive[0].dropbox,path:""});
      setTokens(dropbox.onedrive[0].dropbox);
    } else {
      window.open(
        "https://tpicb.worktual.co.uk/cb/cloudstorage/dropbox/generateURL"+
            "?redirect=" + window.location.origin+"/dbsuccess",
        "sharer",
        "toolbar=0,status=0,width=900,height=518,top=120,resizable=false left=300"
      );
    }

  };
  const onFolderClickHandler = (id: any, drive?:any) => {
    let token: any = localStorage.getItem("access_tokens");
    const dropboxStorage:any = localStorage.getItem('drop_box');
    const dropbox:any = JSON.parse(dropboxStorage);
    if(drive && drive[".tag"]==="folder" &&
    drive.name && dropbox && Object.keys(dropbox).length===5
     && dropbox.access_token){
      TPIService.fetchDropBoxUserFiles(dropbox.access_token,"",{path:id,dropbox:token});
      //let mimedata:any = mime.getType(drive.name);
    } else if(!drive) {
      TPIService.fetchDropBoxUserFiles(dropbox.access_token,"",{path:id,dropbox:token});
    } else {
      let mimedata:any = mime.getType(drive.name);
      TPIService.fetchDropBoxTemporaryURL(dropbox.access_token,mimedata,
        drive["path_display"],
        drive["name"],tokens);
      handleCancel();
    }
    dropRef.current = 1;
  };
  const updateInputSearch = (event:any) =>{
    const toggleFileStatus = dropboxState.dropBoxFiles.slice();
    const finalToggle = toggleFileStatus.filter((values:any)=>values.name.toLowerCase()
      .indexOf(event.target.value.toLowerCase())>-1);
    setToggleFile(finalToggle);
  };
  const toggleView = () => {
    setToggleView(!toggleViews);
  };

  useEffect(() => {
   
    // {Chat attach file - DropBox}
    const DropBoxShareFeature = planBased.find((item:any) => item.featureid === 788);
    if (DropBoxShareFeature && DropBoxShareFeature.value1 === "Yes") {
      setDropBoxbtnhide(false); 
    } else {
      setDropBoxbtnhide(true);
    }
    
  }, [planBased]); 

  return (
    <>
      <li  onClick={loginOAuth} className={`${dropBoxbtnhide ? 'disabledIcon':''}`}><span className="icon_dropbox"></span> Dropbox</li>
      <Modal visible={isModalVisible} className="cloudstorages">
        <div className="modalheaders">
          <h2><img src={dropbox} alt=""/>Dropbox</h2>
          <ul>
            <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Close'}><span className="icon_close"
              onClick={handleCancel}></span></Tooltip></li>
          </ul>
        </div>
        <div className="previewsections">
          <div className="topslayers">
            <h4 onClick={()=>onFolderClickHandler("")}>My Files <span className="icon_down-arrow"></span></h4>
            <URInput placeHolder="Search" onChange={updateInputSearch} className="leftbarsearch" />
          </div>
          {toggleViews && <div className="listviewstorage">
            <div className="titletag">
              <div className="">Name<span className="icon_play"></span></div>
              <div className="">Modified<span className="icon_play"></span></div>
              <div className="">Members<span className="icon_play"></span></div>
              <div className=""><span onClick={toggleView}
                className="icon_Keypadfill"></span> <span className="icon_play"></span></div>
            </div>
            {Array.isArray(toggleFiles) && toggleFiles.length>0 && toggleFiles.map((value:any)=>{
              const fileExt = value.name.split('.').pop();
              return(<><div className="scroller">
                <div className="titletag" onClick={()=>onFolderClickHandler(value?.id, value)}>
                  <div className=""  >
                    <img src={value[".tag"] ==="folder" ? bluefolder :
                      fileExt==="pdf" ? iconpdf : pptFormats.indexOf(fileExt)>-1 ? iconppt:
                        wordFormats.indexOf(fileExt)>-1 ? iconword: excelFormats.indexOf(fileExt)>-1?
                          iconxls: zipFormats.indexOf(fileExt)>-1? iconzip : mp3Formats.indexOf(fileExt)>-1?
                            iconmusic :  imageFormat.indexOf(fileExt)>-1?  iconimage:   notes} alt=""/>
                    {/* {fileExt===""}
                    {fileExt==="pdf"&& <img src={iconpdf} alt=""/>} */}
                    {value.name}</div>
                  <div className="">{value?.server_modified ?
                    moment(new Date(value.server_modified)).format("DD-MM-YYYY HH:mm"):"--"}</div>
                  <div className="">Only you</div>
                  <div className="">{mime.getType(value?.name)}</div>
                </div>
              </div>
              </>);})}
            
          </div>}
          {!toggleViews && <div className="gridviewstorage">
            <div className="titletag">
              <div className="">Name<span className="icon_play"></span></div>
              <div className=""  onClick={toggleView}><span className="icon_listview"></span>
                <span className="icon_play"></span></div>
            </div>
            <><div className="scrollerhover valuetags">
              <div className="titletag">
                {Array.isArray(toggleFiles) && toggleFiles.length>0 && toggleFiles.map((value:any)=>{
                  const fileExt = value.name.split('.').pop();
                  return(
                    <>
                      <div className="gridlistings"  onClick={()=>onFolderClickHandler(value?.id, value)}>
                        <img src={value[".tag"] ==="folder" ? bluefolder :
                          fileExt==="pdf" ? iconpdf : pptFormats.indexOf(fileExt)>-1 ? iconppt:
                            wordFormats.indexOf(fileExt)>-1 ? iconword: excelFormats.indexOf(fileExt)>-1?
                              iconxls: zipFormats.indexOf(fileExt)>-1? iconzip : mp3Formats.indexOf(fileExt)>-1?
                                iconmusic :  imageFormat.indexOf(fileExt)>-1?  iconimage:   notes} alt=""/> {value.name}
                      </div>
                   
                    </>
                  );
                })}
              </div>
            </div></>
          </div>}
        </div>
      </Modal>
    </>
  );
};

export default DropBoxUpload;